// Last-value cache for the cross-panel cursor (the `trackapp:chart-hover` /
// `trackapp:chart-click` payload: { lat, lon, lat2, lon2, distFt, videoTime }).
//
// The cursor events themselves are fire-and-forget window CustomEvents. On
// desktop every panel is always mounted so every listener is live; on mobile
// only the active panel is mounted, so a panel that mounts later (tab switch)
// would otherwise never learn the current position. This module records every
// hover/click dispatch via a single window listener (no producer changes
// needed); consumers seed their handler from lastCursor() on mount. Same
// replay-on-subscribe idea as chartZoomBus.
//
// Deliberately never cleared on `detail: null` (hover leave / touch end): the
// last position must survive finger-lift and tab switches.

let _last = null;

function remember(e) {
  const d = e.detail;
  if (d && Number.isFinite(d.distFt)) _last = d;
}

if (typeof window !== 'undefined') {
  window.addEventListener('trackapp:chart-hover', remember);
  window.addEventListener('trackapp:chart-click', remember);
}

export function lastCursor() {
  return _last;
}
